const currentDate = new Date()
export const MIN_DATE = currentDate.setDate(currentDate.getDate() + 1)
export const MAX_DATE = currentDate.setFullYear(currentDate.getFullYear() + 2)
